import React from 'react';
import styled from 'styled-components';

import media from '../../utils/mediaQueries';

type LegalInformationProps = {
  siretNumber: string;
  establishmentNumber: string;
  ndaNumber: string;
};

const Title = styled.h2`
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: 0.2px;
  color: #354354;
  margin: 40px 0 12px;

  ${media.mobile`
    font-size: 18px;
    margin-top: 24px;
  `}
`;

const Text = styled.p`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: 0.1px;
  font-size: 18px;
  color: #354354;
`;

const LegalInformation = ({
  siretNumber,
  establishmentNumber,
  ndaNumber,
}: LegalInformationProps) => (
  <>
    <Title>Mentions légales</Title>
    <Text>{`n° de SIRET: ${siretNumber}`}</Text>
    <Text>{`n° agrément: ${establishmentNumber}`}</Text>
    <Text>{`n° déclaration d’activité: ${ndaNumber}`}</Text>
  </>
);

export { LegalInformation };
